import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ModelTownCanvas from './ModelTownCanvas';
import GameControls from './GameControls';

const ModelTownBoard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container
      maxWidth={false}
      disableGutters={isMobile}
      sx={{
        py: isMobile ? 0 : 3,
        px: isMobile ? 0 : 3,
        minHeight: '100vh',
        height: isMobile ? '100vh' : 'auto',
        overflow: isMobile ? 'hidden' : 'auto'
      }}
    >
      <Paper
        elevation={isMobile ? 0 : 3}
        sx={{
          p: isMobile ? 0 : 3,
          bgcolor: '#1a1a1a',
          color: '#fff',
          minHeight: '100vh',
          height: isMobile ? '100vh' : 'auto',
          display: isMobile ? 'flex' : 'block',
          flexDirection: isMobile ? 'column' : 'row',
          overflow: 'hidden', // Keep overflow hidden on parent
          position: 'relative'
        }}
      >
        {!isMobile && (
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="h4"
              gutterBottom
              align="center"
              sx={{ fontWeight: 'bold' }}
            >
              Model Town Board (M.T.B)
            </Typography>
            <Typography variant="body2" align="center" color="text.secondary" sx={{ color: '#aaa' }}>
              Practice safe driving - Drag the vehicle along the correct route
            </Typography>
          </Box>
        )}

        <Box sx={{
          flex: isMobile ? 1 : 'none',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden', // ModelTownCanvas handles its own scrolling
          height: isMobile ? '100%' : 'auto'
        }}>
          <ModelTownCanvas />
        </Box>

        {!isMobile && (
          <Box sx={{ mt: 3, p: 2, bgcolor: '#2a2a2a', borderRadius: 2 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Traffic Rules:
            </Typography>
            <Typography variant="body2" component="div">
              <ul style={{ paddingLeft: '20px', lineHeight: '1.8', margin: 0 }}>
                <li>❌ Do NOT go into green areas (off road)</li>
                <li>❌ Do NOT cross continuous yellow lines</li>
                <li>❌ Do NOT cross continuous white lines</li>
                <li>✅ You CAN cross dotted white/yellow lines</li>
                <li>✅ Follow checkpoints to complete the route</li>
              </ul>
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default ModelTownBoard;
